import { apiInstance } from "../../services/api";

import Requirement from "../../domains/Requirement";

import { ENDPOINT } from "./config";

export function fetchRequirementById(id: string): Promise<Requirement> {
  return apiInstance
    .get<Requirement>(`${ENDPOINT}/${id}`)
    .then(resp => resp.data)
    .catch(error => {
      throw new Error(`Requirement By ID Service Error: ${error}`);
    });
}